import { render, staticRenderFns } from "./WorkCertificates.vue?vue&type=template&id=e03dcbee"
import script from "./WorkCertificates.vue?vue&type=script&lang=js"
export * from "./WorkCertificates.vue?vue&type=script&lang=js"
import style0 from "./WorkCertificates.vue?vue&type=style&index=0&id=e03dcbee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports